import React from 'react';
import './Blogs.scss';
import card1 from '../../../Assets/Cards/blogcard1.png';
import card2 from '../../../Assets/Cards/blogcard2.png';
import BlogCard from '../Cards/BlogCard/Card';
import { blogs1Data } from './data';
const Blogs=()=>{
    return(
        <div className="blogs-shared">
         <BlogCard 
          image={card1}
          sub="design"
          title="Productivity hacks & tools for big startups in 2019"
          desc="Ahead of the so-called “most romantic day of the year,” the Lol team sifted through over the wprld…"
          by="laravel poet"
         />
          <BlogCard 
          image={card2}
          sub="collaboration"
          title="The 4 ingredients John Maeda says all the best"
          desc="According to Brian, this org structure provides the easiest route to a clear company mission that all can align to."
          by="jolly nilam"
         />
         <ul  data-aos="fade-left"
        data-aos-delay={100}>
            {blogs1Data.map((item) =>{
                return(
                    <li>
                       <div className="image-blog" style={{ backgroundImage: `url(${item.image})` }}>  </div>
                           <div className="data">
                               <h3>{item.sub}</h3>
                               <h2>{item.title}</h2>
                               <h3>{item.by}</h3>
                           </div>
                     
                    </li>

                )
            })}
        </ul>
        </div>
    )
};
export default Blogs ;